<template>
  <div class="card">
    <label>Soort tasting</label>
    <div class="button-wrapper">
      <button @click="soort($event.target)">APERATIVO</button>
      <button @click="soort($event.target)">SALADE</button>
      <button @click="soort($event.target)">OVERLEG</button>
    </div>
    <div class="input-wrapper">
      <label>Aantal personen (4 of meer)</label>
      <input type="number" min="4" v-model="info.aantal" />
      <label>Naam</label>
      <input type="text" v-model="info.naam" /><label>Telefoonnummer</label>
      <input
        class=""
        type="tel"
        v-model="info.telefoonnummer"
        @input="changeInput($event)"
      /><label>E-mailadres</label>
      <input
        type="email"
        v-model="info.email"
        @input="changeInput($event)"
      /><label>Datum/dag/periode</label>
      <input type="text" v-model="info.datum" />
      <button class="item disabled" :disabled="enabled" @click="sendOffer()">Aanvragen</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      soortProeverij: "",
      info: {
        aantal: 4, // Set the default value of aantal to 4
        naam: "",
        telefoonnummer: "",
        email: "",
        datum: ""
      },
    }
  },
  // mounted() {

  // },
    methods: {
  soort(button) {
    // Disable all buttons

    const buttons = document.querySelectorAll('.button-wrapper button');
    buttons.forEach(btn => {
      // btn.disabled = true;
      btn.classList.remove('green', 'selected');
    });

    // Enable the clicked button and make it green
    button.disabled = false;
    button.classList.add('green', 'selected');

    // Update soortProeverij based on the clicked button
    this.soortProeverij = button.innerHTML;

    // Check if the form should be enabled
    this.checkEnabled();
  },

  checkEnabled() {
    console.log('');
      if (
        !this.soortProeverij ||
        this.info.aantal < 4 ||
        this.info.naam == "" ||
        this.info.email == "" ||
        this.info.telefoonnummer == "" ||
        this.error.length != 0
      ) {
        this.enabled = true;
      } else {
        this.enabled = false;
      }
    },

    chosen(button) {
      if (this.selectedButton === button) {
        button.classList.remove("selected");
        this.aantal = "";
        this.selectedButton = null;
      } else {
        if (this.selectedButton) {
          this.selectedButton.classList.remove("selected");
        }
        button.classList.add("selected");
        this.selectedButton = button;
        this.aantal = button.innerHTML;
      }
      this.checkEnabled();
    },


    async sendOffer() {
      console.log(this.info)
      const requestOptions = {
        method: "POST",
        body: JSON.stringify({
          proeverij: this.soortProeverij,
          naam: this.info.naam,
          telefoonnummer: this.info.telefoonnummer,
          email: this.info.email,
          aantal: this.info.aantal,
          datum: this.info.datum,
        }),
      };
      const response = await fetch(
        "https://vomfass-food.nl/api/v2/vomfassie/requestTasting/",
        requestOptions
      );
      await response.json();
      this.info= {
        aantal: 4, // Set the default value of aantal to 4
        naam: "",
        telefoonnummer: "",
        email: "",
        datum: ""
      }
      
    },
    
    changeInput(input) {
      let sort = input.target.type;
      let answer = input.target.value;
      
      switch (sort) {
        case "tel":
          if (/(\d+(?:\.\d+)?)$/.test(answer)) {
            input.target.classList.remove("error");
          } else {
            input.target.classList.add("error");
          }
          break;
        case "email":
          if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(answer)) {
            input.target.classList.remove("error");
          } else {
            input.target.classList.add("error");
          }
          
          break;
        default:
      }
      this.error = document.getElementsByClassName("error");
      this.checkEnabled();
    },
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #00335b;
}
.card {
  text-align: left;
  font-weight: 700;
}
.button-wrapper,
.card {
  width: 100%;
}
button {
  height: 56px;
  border-radius: 5px;
  background: rgba(10, 161, 139, 0.6);
  font-weight: 700;
  color: #00335b;
  margin: 5px 0 5px 0;
}
.button-wrapper button {
  width: 33%;
  padding: 5px;
}
.input-wrapper {
  display: flex;
  flex-direction: column;
}
input {
  border: 1px solid #0aa18b;
  border-radius: 10px;
  font-size: large;
  padding: 15px;
}
input[type="number"] {
  width: 60px;
}
.green {
  border: 2px solid #0aa18b;
  background-color: #0aa18b;
  color: #fdfdfd;
}
.selected {
  background: #0aa18b !important;
  color: #fdfdfd;
}
.error {
  color: red;
}
.noerror {
  color: #000;
}
.conformation {
  border-radius: 5px;
  border: 1px solid #00335b;
  height: 50px;
  background-color: #0aa18b;
  top: 210px;
  margin: auto;
}
.conformation h3 {
  text-align: center;
}
</style>
